import { render, staticRenderFns } from "./VideoUtil.vue?vue&type=template&id=1787f044"
import script from "./VideoUtil.vue?vue&type=script&lang=js"
export * from "./VideoUtil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports